export const TAG_CONFIGS = {
    verified: { iconName: 'IconVerified', label: 'Verified' },
    topRated: { iconName: 'IconTopRated', label: 'Top rated' },
    rentStabilized: { iconName: 'IconRentStabilized', label: 'Rent-stabilized' },
    goodCause: { iconName: 'IconGoodCause', label: 'Good cause' },
    future: { iconName: 'IconFuture', label: 'Future' },
    worstLandlord: { iconName: 'IconWorstLandlord', label: 'Worst landlord' },
};
export const HIGHLIGHT_DESCRIPTIONS = {
    verified: {
        title: 'Verified apartment listing',
        description: 'This apartment has confirmed availability and you can apply to this apartment directly.',
    },
    topRated: {
        title: 'Top rated building',
        description: 'This building is highly reviewed and rated 4+ stars by past and current renters.',
    },
    rentStabilized: {
        title: 'Rent-stabilized apartments',
        description: 'This building has apartments that entitle you to a renewal and limited rent increases.',
    },
    goodCause: {
        title: 'Good cause building',
        description: 'This building guarantees a renewal and capped rent increases, if you follow your lease terms.',
    },
    future: {
        title: 'Future apartment listing',
        description: 'This apartment is not available yet, but it can be matched to you before it hits the market.',
    },
    worstLandlord: {
        title: 'Worst landlord',
        description: 'This owner or associate is ranked in the top 100 worst landlords in NYC.',
    },
};
